import React from "react";
import {Locale} from "~/i18n-config";
import {useSearchParams} from "next/navigation";
import {LangLink} from "~/components/locales/LangLink";
import clsx from "clsx";
import Link from "next/link";
import {NavigationItem} from "@/utils/content/navigation";

export function NavigationLink(
    { lang, item, className, prepend, append } : {
    lang: Locale;
    item: NavigationItem;
    className?: string;
    prepend?: React.ReactNode;
    append?: React.ReactNode;
}) {

    const searchParams = useSearchParams();

    const hasChildren = item.children && item.children.length > 0;

    const classNames = clsx(
        hasChildren ? "has-children" : "no-children",
        "select-none",
        className
    );

    if (item.linkType === "No Link") {
        return (
            <span className={classNames}>
                {prepend}
                {item.name}
                {append}
            </span>
        );
    }

    const target = item.openInNewTab === "Yes" ? "_blank" : "_self";
    const rel = item.noFollow === "Yes" ? "nofollow" : "follow";

    if (item.linkType === "External" && item.externalLink) {
        return (
            <Link
                href={{
                    pathname: item.externalLink,
                    query: Object.fromEntries(searchParams.entries()),
                }}
                target={target}
                rel={rel}
                className={classNames}>
                {prepend}
                {item.name}
                {append}
            </Link>
        );
    }

    if (item.linkType === "Internal") {
        return (
            <LangLink
                lang={lang}
                href={{
                    pathname: (item.entity && item.entity.value) ? `/${item.entity.value.slug}` : `/${item.pathname}`,
                    query: searchParams,
                }}
                target={target}
                rel={rel}
                className={classNames}>
                {prepend}
                {item.name}
                {append}
            </LangLink>
        );
    }

    return (
        <span className={classNames}>
            {prepend}
            {item.name}
            {append}
        </span>
    );

}
